import React from 'react';
import { IconButton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import ArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTranslation } from 'services/localization/useTranslation';

const TablePaginationActions = (props: TablePaginationActionsProps) => {
	const { count, page, rowsPerPage, onPageChange } = props;
	const classes = useStyles();
	const { t } = useTranslation();

	const from = count === 0 ? 0 : page * rowsPerPage + 1;
	const to = rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);

	const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<div className={classes.root}>
			<IconButton color="secondary" onClick={handleFirstPageButtonClick} disabled={page === 0}>
				<FirstPageIcon />
			</IconButton>
			<IconButton color="secondary" onClick={handleBackButtonClick} disabled={page === 0}>
				<ArrowLeftIcon />
			</IconButton>
			<Typography variant="body2" color="secondary" component="span">
				{t('users.fromToOfTotal', {
					defaultValue: '{{from}}-{{to}} of {{total}}',
					from,
					to,
					total: count,
				})}
			</Typography>
			<IconButton
				color="secondary"
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
			>
				<ArrowRightIcon />
			</IconButton>
			<IconButton
				color="secondary"
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
			>
				<LastPageIcon />
			</IconButton>
		</div>
	);
};

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			flexShrink: 0,
			marginLeft: theme.spacing(2.5),
		},
	}),
);

export default TablePaginationActions;
